import React from "react";
import { FormField } from "./FormField";
import { IoAddCircleOutline } from "react-icons/io5";
import ImagePreview from "./ImagePreview";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { compressImage } from "../App/Helpers/compressImage";

function UploadSingleImage({
  label,
  tooltip,
  name,
  value,
  id,
  handleFileUpload,
}) {
  const fileUpload = (e) => {
    const f = e.target.files[0];

    compressImage(f, (ci) => {
      handleFileUpload && handleFileUpload(ci);
      //   return ci
    });
  };
  return (
      <FormField label={label || "Image"} tooltip={tooltip || "Choose Image"}>
    <div className="w-52 h-52 overflow-hidden shadow-2xl text-center rounded-xl flex items-center justify-center">
        <label htmlFor={name || "image"} className="cursor-pointer">
         {!value&& <IoAddCircleOutline
            className="text-5xl text-slate-500 rounded-full m-[auto] cursor-pointer"
            id={name + "icon" || "image-icon"}
          />}
          <input
            type="file"
            id={name || "image"}
            accept="image/*"
            name={name || "image"}
            onChange={(e) => fileUpload(e)}
            style={{ display: "none" }}
            required
          />
          {value ? "" : <span>Add {label || "Image"}</span>}
          {typeof value !== "object" ? (
            <LazyLoadImage
              src={value}
              alt="img"
              loading="lazy"
              effect="blur w-full h-full"
              style={{
                width: "100%!important",
                height: "100% !important",
                objectFit: "contain",
              }}
              className="rounded-xl cursor-pointer"
            />
          ) : (
            <ImagePreview
              file={value}
              id={name + "preview" || "image-preview"}
            />
          )}
        </label>
    </div>
      </FormField>
  );
}

export default UploadSingleImage;
